import React from 'react';

/**
 * Components
 */
import Select from 'Components/Select';
import BoatsList from './BoatsList';
import { Input } from 'Components/Input';
import Checkbox from 'Components/Checkbox';
import DatePicker from 'Components/DatePicker';

export default ({
  inputErrors,
  handleSelect,
  handleYearSelect,
  yearsList,
  handleTagTypeSelect,
  handleReportSubTypeSelect,
  handleToggleValue,
  handleInputChange,
  addBoat,
  removeBoat,
  reportSubType,
  tagType,
  reportYear,
  RUSH,
  PO,
  reportDate,
  selectedBoatsList,
  handleBoatParamChange,
  handleDateChoose,
}) => {
  const reportSubTypesList = ['Regular', 'CARB'];
  const tagTypesList = ['Mylar', 'Aluminum'];

  return (
    <React.Fragment>
      <section className='report-subtype-choose-section'>
        <header>Report Type</header>
        <Select
          selectionList={reportSubTypesList}
          mainWrapperClassName='_width_330 _height_90'
          inputClassName='_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20'
          dropDownClassName='_border_radius_bottom_left_10 _border_radius_bottom_right_10'
          defaultItem={reportSubType}
          withoutSearch
          isSlave
          label='Report Subtype *'
          error={inputErrors.reportSubType}
          handleSelect={handleReportSubTypeSelect}
        />
        {reportSubType && (
          <Select
            selectionList={tagTypesList}
            mainWrapperClassName='_width_330 _height_90'
            inputClassName='_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20'
            dropDownClassName='_border_radius_bottom_left_10 _border_radius_bottom_right_10'
            defaultItem={tagType}
            label='Tag Type *'
            error={inputErrors.tagType}
            handleSelect={handleTagTypeSelect}
            withoutSearch
            disabled={reportSubType === 'CARB'}
          />
        )}
      </section>

      {reportSubType && tagType && (
        <React.Fragment>
          <section className='report-filters-section'>
            <header>Additional Information</header>
            <Select
              selectionList={yearsList}
              mainWrapperClassName='_width_330 _height_90'
              inputClassName='_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20'
              dropDownClassName='_border_radius_bottom_left_10 _border_radius_bottom_right_10'
              defaultItem={reportYear}
              label='Model Year *'
              error={inputErrors.reportYear}
              withoutSearch
              handleSelect={handleYearSelect}
            />
            <div className='checkbox-wrapper'>
              <Checkbox label='RUSH' value={RUSH} onChange={handleToggleValue('RUSH')} />
            </div>
            <Input
              label='PO #'
              inputClassName='_border_radius_10 _margin_bottom_20 _margin_top_12 _height_40 _width_330'
              error={inputErrors.PO}
              value={PO}
              onChange={handleInputChange('PO')}
            />
            <DatePicker
              label='Delivery Date'
              error={inputErrors.reportDate}
              selectedDate={reportDate}
              handleSelectDate={handleDateChoose}
            />
          </section>
          <BoatsList
            reportSubType={reportSubType}
            tagType={tagType}
            handleInputChange={handleInputChange}
            addBoat={addBoat}
            removeBoat={removeBoat}
            selectedBoatsList={selectedBoatsList}
            handleBoatParamChange={handleBoatParamChange}
            inputErrors={inputErrors}
            reportYear={reportYear}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/ReportScene/CARBReport/index.jsx